import React from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { uploadTypesTitles } from './Upload/uploadTypes';
import AUX from '../../hoc/AU-X/AU-X';
import { logout } from '../../store/index';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';

const UploadDetails = (props) => {
  const dispatch = useDispatch();

  return (
    <AUX>
      <div className='homePage'>
        <NavLink className='goBack' to='/SelectFolder'>
          <Icon path={mdiArrowLeft} size={1} title='go back' />
        </NavLink>

        <div className='healthDays'>
          {uploadTypesTitles.map((element) => (
            <NavLink key={element} to={`UploadData/${element}`}>
              {element}
            </NavLink>
          ))}
        </div>
      </div>
      <div className='logout' onClick={() => dispatch(logout())}>
        logout
      </div>
    </AUX>
  );
};

export default UploadDetails;
